import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';
import { KeypadSchema } from '@/components/Betslip/components/Keyboard/styles/Keypad.styles';

export const keypadStyles: KeypadSchema = {
  buttonActionProps: {
    variant: 'outline',

    color: 'beta.400',
    height: '5',
    border: '2px solid',
    borderColor: 'beta.50',
    mb: '1',

    _hover: {
      '&&': {
        background: 'transparent',
      },
    },
  },
};

export const FlexKeypadWrapper: CSSObject = {
  p: '0.5',
  width: ['100%', null, '102%', '100%'],
  left: [null, null, '0'],
  bg: 'alpha.900',
  borderTop: '2px',
  borderTopColor: 'beta.50',
};

export const buttonKeysProps: CustomButtonProps = {
  variant: 'secondary',
  height: '100%',
  fontSize: 'md',
  border: 'none',
  color: 'white',
  boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.15)',
  fontWeight: 'bold',
  textShadow: '0px 2.82px 3.761px rgba(0, 0, 0, 0.30)',
  bgGradient: 'linear(to-b, alpha.300, alpha.400)',
  fontFamily: 'Roboto',
  _hover: {
    bgGradient: 'linear(to-b, alpha.400, alpha.700)',
  },
};

export const buttonDoneKeyProps: CustomButtonProps = {
  variant: 'secondary',
  height: '100%',
  fontSize: 'md',
  fontFamily: 'Roboto',
  border: 'none',
  color: 'white',
  bgGradient: 'linear(to-b, alpha.300, alpha.400)',
  textTransform: 'uppercase',
  fontWeight: 'bold',
  textShadow: '0px 2.82px 3.761px rgba(0, 0, 0, 0.30)',
  boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.15)',
};

export const buttonBatchKeysProps: CustomButtonProps = {
  variant: 'secondary',
  height: '100%',
  fontSize: 'md',
  fontFamily: 'Roboto',
  bgGradient: 'linear(to-b, beta.300, beta.400)',
  color: 'alpha.800',
  border: 'none',
  fontWeight: 'bold',
  textShadow: '0px 2.82px 3.761px rgba(255, 255, 255, 0.30)',
  boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.15)',
};
